import { BASE_URL } from "@/constants/endpoints";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { objectToQueryStringWithArray } from "@/utils/query-string";
import {
  FieldVisitDetail,
  FieldVisitListResponse,
} from "@/pages/ata-rsa-production/field-visit/schema/field-visit.schema";
import { AxiosInstance } from "axios";

let fieldVisitApiPromise: Promise<AxiosInstance> | null = null;

const getFieldVisitApi = async (): Promise<AxiosInstance | null> => {
  if (fieldVisitApiPromise !== null) return fieldVisitApiPromise;
  fieldVisitApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return fieldVisitApiPromise;
};

export const FIELD_VISIT_BASE_PATH = "/VisitaCampo";

export interface GetFieldVisitsProps {
  "P.Pagina"?: number;
  "P.Records"?: number;
  Estados?: number[];
  FechaDeseada?: string;
  CuentaOrigen?: number;
}

export const getFieldVisits = async (
  props: GetFieldVisitsProps = {},
): Promise<FieldVisitListResponse | null> => {
  const api = await getFieldVisitApi();
  if (!api) return null;

  const queryString = objectToQueryStringWithArray(props);
  const url = queryString ? `${FIELD_VISIT_BASE_PATH}?${queryString}` : FIELD_VISIT_BASE_PATH;
  const response = await api.get(url);
  return response.data;
};

export interface CreateFieldVisitBody {
  cuentaOrigen: number;
  contacto: string;
  idUsuarioMobile?: string;
  idProcedencia: string;
  motivoVisita: string;
  fechaDeseada: string;
  observacionProductor: string;
}

export const createFieldVisit = async (body: CreateFieldVisitBody) => {
  const api = await getFieldVisitApi();
  if (!api) return null;

  const response = await api.post(FIELD_VISIT_BASE_PATH, body);
  return response.data;
};

export interface PatchFieldVisitBody {
  id: number;
  idEstado: number;
  idTecnico?: number;
  fechaFinal?: string;
  observacionTecnico?: string;
  motivoRechazo?: string;
}

export const patchFieldVisit = async (body: PatchFieldVisitBody) => {
  const api = await getFieldVisitApi();
  if (!api) return null;

  const response = await api.patch(FIELD_VISIT_BASE_PATH, body);
  return response.data;
};

export interface GetFieldVisitDetailProps {
  id: number;
}

export const getFieldVisitDetail = async (
  props: GetFieldVisitDetailProps,
): Promise<FieldVisitDetail | null> => {
  const api = await getFieldVisitApi();
  if (!api) return null;

  const response = await api.get(`${FIELD_VISIT_BASE_PATH}/${props.id}`);
  return response.data;
};
